module.exports = __webpack_public_path__ + "static/media/files.f93109ab.svg";